/*
 * Copyright (c) Nexign, JSC, 2025.
 */

/**
 * Rateplan card utils
 *
 * @author Nikolay Sviridov
 * @version 1.39.0
 * @since 1.39.0
 */

import { IPageProductsTranslation } from '@modules/internationalization/types/pages/products';
import {
    EProductCardTariffRoamingType,
    IProductCardTariffField,
    IProductCardTariffFieldRoaming,
} from '@pages/PageProducts/tariffsAndServicesProductTariffTypes';

export const PRODUCT_CARD_CAMPAIGN_TARIFF_UNLIMITED_VALUE = 999999999;

export const checkCommaAfterThisInternetLimited = (
    index: number,
    cardTranslation: IPageProductsTranslation['campaignTariffsCard'],
    internetLimited?:  IProductCardTariffField<string[]>,
): string => (
    internetLimited?.value[index + 1] &&
    cardTranslation.internetLimited[internetLimited.value[index + 1].valueOf()]
        ? ', ' : ''
);

export const checkValueUnlimited = (
    roaming: IProductCardTariffFieldRoaming,
    cardTranslation: IPageProductsTranslation['campaignTariffsCard'],
): [boolean, string | undefined] => {
    const { value, type } = roaming;
    const { roamingUnlimitedValues } = cardTranslation;

    const returnValue = (
        type: IProductCardTariffFieldRoaming['type'],
    ) =>  type
        ? {
            [EProductCardTariffRoamingType.Calls]: roamingUnlimitedValues.calls,
            [EProductCardTariffRoamingType.Internet]: roamingUnlimitedValues.internet,
            [EProductCardTariffRoamingType.InternetLimited]: roamingUnlimitedValues.internet,
            [EProductCardTariffRoamingType.SMS]: roamingUnlimitedValues.sms,
        }[type]
        : undefined;

    return +value === PRODUCT_CARD_CAMPAIGN_TARIFF_UNLIMITED_VALUE
        ? [true, returnValue(type)]
        : [false, value]
};

export const getRoamingTooltip = (
  roaming: IProductCardTariffFieldRoaming,
  cardTranslation: IPageProductsTranslation['campaignTariffsCard'],
): string | undefined =>
    roaming.routeIds
      ?.map(routeId => cardTranslation.roaming[routeId]?.tooltip)
      .filter(tooltip => !!tooltip)
      .join(', ') ?? undefined;
